import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { t } from 'ttag';
import { InfoOutlined } from '@material-ui/icons';

import useStyles from './styles';

const NoAlerts: React.FC<any> = () => {
  const classes = useStyles();

  return (
    <Grid container direction={'column'} className={classes.noContentContainer}>
      <div className={classes.imageContainer}>
        <InfoOutlined className={classes.icon} />
      </div>
      <div className={classes.textContainer}>
        <Typography className={classes.noAlertsText}>
          {t`No alerts found for the selected filters`}
        </Typography>
      </div>
    </Grid>
  );
};

export default NoAlerts;
